import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";
import ToolSidebar from "../../utils/ToolSideBar";
import "../../../css/client/ClientProfile.css";

export default function ClientProfile({ data, loading }) {
  const user = data?.user || {};
  const projects = data?.projects || [];
  const [form, setForm] = useState({ first_name: "", last_name: "", display_name: "", phone_number: "" });
  const [status, setStatus] = useState("");

  useEffect(() => {
    setForm({
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      display_name: user.display_name || "",
      phone_number: user.phone_number || "",
    });
  }, [user.first_name, user.last_name, user.display_name, user.phone_number]);

  async function saveProfile(event) {
    event.preventDefault();
    setStatus("Saving profile...");
    const response = await authFetch(`${API_URL}/client/profile/`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    const payload = await response.json();
    setStatus(response.ok ? "Profile saved." : payload.detail || "Unable to save profile.");
  }

  if (loading) return <div className="profile-loading">Loading...</div>;

  return (
    <div className="profile-shell">
      <ToolSidebar active="profile" />
      <div className="profile-page">
        <div className="profile-header"><h1>Profile</h1><p>Manage your client contact details and project summary.</p></div>
        <div className="profile-grid">
          <form className="profile-card" onSubmit={saveProfile}>
            <h3>Contact Details</h3>
            <label className="profile-field">First Name<input value={form.first_name} onChange={(e) => setForm((current) => ({ ...current, first_name: e.target.value }))} /></label>
            <label className="profile-field">Last Name<input value={form.last_name} onChange={(e) => setForm((current) => ({ ...current, last_name: e.target.value }))} /></label>
            <label className="profile-field">Display Name<input value={form.display_name} onChange={(e) => setForm((current) => ({ ...current, display_name: e.target.value }))} /></label>
            <label className="profile-field">Phone<input value={form.phone_number} onChange={(e) => setForm((current) => ({ ...current, phone_number: e.target.value }))} /></label>
            <button type="submit" className="profile-save">Save Profile</button>
            {status && <small>{status}</small>}
          </form>
          <div className="profile-card">
            <h3>Account</h3>
            <div className="profile-row"><span>Email</span><strong>{user.email || "Not provided"}</strong></div>
            <div className="profile-row"><span>User ID</span><strong>{user.user_id || "Not provided"}</strong></div>
            <div className="profile-row"><span>Joined</span><strong>{user.created_at ? new Date(user.created_at).toLocaleDateString() : "Not provided"}</strong></div>
            <div className="profile-row"><span>Total Projects</span><strong>{projects.length}</strong></div>
          </div>
        </div>
        <div className="profile-card full">
          <h3>Project History</h3>
          {projects.length === 0 ? <p className="text-muted">No approved projects found.</p> : projects.map((project) => (
            <div key={project.id} className="profile-row"><div><strong>{project.project_name}</strong><div>{project.status_label} - {project.progress_percentage}%</div></div><div>{project.selected_plan}</div></div>
          ))}
        </div>
      </div>
    </div>
  );
}